<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    #sidenav
    fixedInViewport [fixedTopGap]="64"
    mode="over"
    position="end"
    class="mobile-sidenav">
    <div class="sidenav-header">
      <button mat-icon-button class="close-btn" aria-label="Close menu" (click)="sidenav.close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-nav-list>
      <a mat-list-item routerLink="/" (click)="sidenav.close()">Home</a>
      <a mat-list-item routerLink="/our-team" (click)="sidenav.close()">Our Team</a>
      <a mat-list-item routerLink="/conditions" (click)="sidenav.close()">Conditions We Treat</a>
      <a mat-list-item routerLink="/contact-us" (click)="sidenav.close()">Contact Us</a>
      <a mat-list-item routerLink="/enquire" (click)="sidenav.close()" class="primary">Enquire</a>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar class="fixed-header">
      <div class="logo-container">
        <button mat-button [routerLink]="'/'" class="button" color="primary" aria-label="Navigate to homepage">
          <app-logo-advanced></app-logo-advanced>
        </button>
      </div>

      <!-- Desktop Navigation Buttons -->
      <span class="nav-buttons">
        <app-button-shared buttonType="home" variant="basic" color="default"></app-button-shared>
        <app-button-shared buttonType="our-team" variant="basic" color="default"></app-button-shared>
        <app-button-shared buttonType="conditions" variant="basic" color="default"></app-button-shared>
        <app-button-shared buttonType="contact-us" variant="basic" color="default"></app-button-shared>
        <app-button-shared buttonType="enquire" variant="flat" color="primary"></app-button-shared>
      </span>

      <!-- Mobile Menu (Hidden on Desktop) -->
      <button mat-fab color="primary" class="burger-menu" aria-label="Open menu" (click)="$event.stopPropagation(); sidenav.toggle()">
        <mat-icon>menu</mat-icon>
      </button>
    </mat-toolbar>
    <mat-divider></mat-divider>
  </mat-sidenav-content>
</mat-sidenav-container>
